import Container from './LeaseSelector.container';

export default Container;
